package link.erpango.quip.domain.entities

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient

@Serializable
data class DUser(
    val id: String?,
    val email: String?,
    val name: String?,
    val avatar: String?,
)

@Serializable
data class DAuth(
    val user: String? = null,
    val access: String? = null,
    val refresh: String? = null,
    @Transient
    val expiresIn: Long? = null,
    @Transient
    val createdAt: Long? = null
)


@Serializable
data class DLoginRequest(

    val username: String,
    val password: String
)

@Serializable
data class DGoogleLoginRequest(
    val idToken: String
)


@Serializable
data class JwtPayload(
    val id: Int,
    val email: String,
    val exp: Long,
    val iat: Long
)

@Serializable
data class DRegisterRequest(
    val name: String,
    val email: String,
    val password: String
)

@Serializable
data class DRefreshRequest(val refresh: String)